import Landing from "./Cloudash/Landing";
import Page2 from "./Cloudash/Page2";   
import React from "react";

const Autocicd = () => {
    return (
      <div>
        
        <Landing />
        <Page2 />
       
        
      </div>
    )
  }
  
  export default Autocicd
